import { render } from "./TeamTypeSelection.vue?vue&type=template&id=592d478a"
import script from "./TeamTypeSelection.vue?vue&type=script&lang=js"
export * from "./TeamTypeSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__